<template>
    <div>
        <md-card class="review-issues-container">
            <md-card-header class="md-card-header-icon md-card-header-warning">
                <div class="card-icon icon-style">
                    <md-icon>warning</md-icon>
                    Issues
                </div>
                <create-issue
                    :related-entity-type="entityType"
                    :related-entity-ref="entityRef"
                    :open-dialog="isReview"
                    class="create-issue-container"
                    @issueCreated="addLogToInvoicePage"
                />
            </md-card-header>

            <div v-if="issues && issues.length > 0" class="log-container">
                <md-card-content v-for="(issue, index) in issues" :key="index" class="issue-container">
                    <md-card>
                        <md-card-content>
                            <router-link
                                :to="{
                                    name: 'Issues Overview',
                                    query: { ref: `${issue.issueReference}` }
                                }"
                                target="_blank"
                            >
                                {{ issue.issueReference }}
                            </router-link>

                            <div class="details-box">
                                <label>Title</label>
                                <span>
                                    {{ issue.title }}
                                </span>
                            </div>

                            <div class="details-box">
                                <label>Status</label>
                                <span>
                                    {{ issue.statusName }}
                                </span>
                            </div>

                            <div class="details-box">
                                <label>Created by</label>
                                <span>
                                    {{ issue.createdByName }}
                                </span>
                            </div>

                            <div class="details-box">
                                <label>Created</label>
                                <span>
                                    {{ issue.createdDate | dateFormat(DATE_TYPES.standardDate) }}
                                </span>
                            </div>
                        </md-card-content>
                    </md-card>
                </md-card-content>
            </div>
            <div class="no-issues-container" v-else>
                No issues exist.
            </div>
        </md-card>
    </div>
</template>

<script>
import { CreateIssue } from '@/pages/Issues/Components';
import { DATE_TYPES } from '@/utils/constants';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';

export default {
    name: 'ReviewInvoiceIssues',
    components: {
        CreateIssue
    },
    mixins: [GeneralMixin],
    data() {
        return {
            DATE_TYPES
        };
    },
    props: {
        entityId: {
            type: Number,
            required: true
        },
        entityRef: {
            type: String,
            required: true
        },
        entityType: {
            type: String,
            required: true
        },
        issues: {
            type: Array,
            default: () => {}
        },
        invoiceStatus: {
            type: String,
            default: null
        }
    },
    computed: {
        isApprove() {
            return this.$route.query.action?.toLowerCase() === 'approve';
        },
        isReview() {
            return this.$route.query.action?.toLowerCase() === 'review';
        }
    },
    async mounted() {
        if (this.isApprove && this.invoiceStatus === 'Draft') {
            await this.approveInvoice();
        } else if (this.isApprove && this.invoiceStatus !== 'Draft') {
            this.$notifySuccess('Invoice has already been approved.');
        }
    },
    methods: {
        openIssue(issueReference) {
            const issueData = this.$router.resolve({ name: 'Issues Overview' });
            const issueUrl = `${issueData.href}?ref=${issueReference}`;

            window.open(issueUrl, '_blank');
        },
        async approveInvoice() {
            if (this.entityId == null) {
                showErrorMessage(this, 'No invoice selected');
                return;
            }

            this.$_handleLoaderState(true, 'APPROVING...');

            const payload = {
                method: 'post'
            };

            const api = `/api/team-member-invoices/${this.entityId}/approve`;

            try {
                await handleRequests(api, payload);
                this.$notifySuccess('Invoice was approved!');
                this.$emit('invoiceApproved', { result: true, invoiceId: this.entityId });
            } catch (e) {
                const message = 'Error in approving the invoice.';
                showErrorMessage(this, message, e);
            }

            this.$_handleLoaderState(false);
        },
        addLogToInvoicePage(data) {
            const issueMapped = data.map((i) => {
                return {
                    issueReference: i.issueReference,
                    title: i.title,
                    statusName: i.statusName,
                    createdByName: i.createdByName,
                    createdDate: i.createdDate
                };
            });

            this.issues.unshift(issueMapped[0]);
            this.removeActionQuery('action');
        },
        removeActionQuery(param) {
            const query = { ...this.$route.query };
            delete query[param];

            this.$router.replace({ query });
        }
    }
};
</script>

<style scoped>
.issue-container {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

.create-issue-container {
    padding-top: 15px;
    padding-right: 10px;
    float: right !important;
}

.log-container {
    overflow-y: scroll;
    max-height: 293px;
}

.review-issues-container {
    height: 361px;
}

.no-issues-container {
    align-self: center;
    margin-top: 100px;
    font-weight: 400;
}

.icon-style {
    color: white;
}
</style>
